import type { ReactElement } from 'react'

import {
  Headline,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'

type Props = {
  title: ReactElement
  subtitle: ReactElement
}
export const IntroStepContentHeadline = ({ title, subtitle }: Props) => (
  <Headline align="start">
    <HeadlineTitle>{title}</HeadlineTitle>
    <HeadlineSubtitle>{subtitle}</HeadlineSubtitle>
  </Headline>
)
